export const environment = {
  production: false,
  api: {
    url: 'https://api.losandespass.com.ar',
    version: '2',
    environment: 'prod',
    auth: {
      login: '/api/v2/auth/lap/login'
    },
    endpoints: {
      profile: 'auth/lap/me',
      provincias: 'tables/provincias',
      localidades: (id: number) => `tables/localidades?idprovincia=${id}`
    }
  },
  apiKeys: {
    benefits: 'sk-tabl-uEb9FBOuUSI3BbZM0BxAPocU3ejgHAcX',
    tables: 'sk-tabl-uEb9FBOuUSI3BbZM0BxAPocU3ejgHAcX',
    suscripciones: 'sk-susc-0gE5hTCn8eeB2MbdojDclxLOcjB0E_gU',
    status: 'sk-stat-KkTX0v0elcraF6lw8FsH13k_AodGkqZ4'
  },
  pageSize: 50
};
